

// verifyCondition_unselected: Esta función verifica si se cumple la condición para que se 
// renderice el componente.
export const verifyCondition_unselected = ( socketConnected, sessionsChatSelected  ) => {
    let condition = (
        !socketConnected || sessionsChatSelected.length === 0
    );
    return condition;
}
